import React from "react";
import LogoApp from "./img/logo.png"
import Offcanvas from "./Offcanvas";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg sticky-top  modify-navbar p-3">
        <div className="container-fluid">
          <div className="offside-canvas-holder d-flex d-sm-flex d-md-none">
            <Offcanvas/>
          </div>
          <Link className="navbar-brand" to ="/">
            <img src={LogoApp} className=" rounded-1 me-2 app-logo" alt="App logo" />
            Quiz Master
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="#navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to ="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to ="/quizsection">
                  Quiz
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to ="/certification">
                  Get Certification
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to ="/login">
                  Login
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to ="/about">
                  About
                </Link>
              </li>
            </ul>
            <form className="d-flex" role="search">
              <input
                className="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button className="btn btn-outline-success" type="submit">
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
